import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(3)
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1)
    }
  },
  titleSection: {
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(3)
  },
  containerGridBackground: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
    marginTop: theme.spacing(1),
    boxShadow: '0px 4px 14px rgba(151, 149, 149, 0.04)',
    borderRadius: '30px'
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(1)
  },
  collaboratorImg: {
    borderRadius: '50%',
    width: '120px',
    [theme.breakpoints.down('sm')]: {
      width: '100px'
    }
  },
  name: {
    fontWeight: 600,
    lineHeight: 'normal',
    whiteSpace: 'pre-line'
  },
  position: {
    fontWeight: 600
  },
  collaboratorLinkGroup: {
    display: 'flex',
    gap: theme.spacing(0.5)
  },
  collaboratorLink: {
    width: '30px'
  }
}))
